import type { ScholarshipPurpose } from '../../../../types/scholarships';

/**
 * Whether a board is a recruiting board. Only the exact purpose counts: Scholarship is the default,
 * and boards created before the purpose field existed have none, so both read as a roster board
 * (the same split ScholarshipsSection uses for its two lists).
 *
 * Recruiting boards get a simpler presentation (10/4 client feedback): "Configure board" instead of
 * "Configure roster", no Lineups tab, a "Pitchers" tab, and a shorter player dialog. Everything the
 * simpler views hide is still stored and re-sent, so nothing is lost if a coach later needs it.
 */
export const isRecruitingBoard = (board: { purpose?: ScholarshipPurpose | null }): boolean =>
  board.purpose === 'Recruiting';

/** What the board's settings dialog is called, on its button, its title and in hints that name it. */
export const configureBoardLabel = (board: { purpose?: ScholarshipPurpose | null }): string =>
  isRecruitingBoard(board) ? 'Configure board' : 'Configure roster';
